import React from 'react';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';
import { Helmet } from 'react-helmet';
import _ from 'lodash';
import { BigBreadcrumbs, WidgetGrid } from '../../../components';
import Moment from '../../../components/utils/Moment';
import { requestEvent } from '../../../store/event-manager/EventManagerActions';
import { hostTitle } from '../../../config/ui';

class EventManagerDetail extends React.Component {
  componentWillMount() {
    this.props.getEvent(this.props.params.meetingId, {
      tenantID: this.props.tenantId,
    });
  }

  onCancel = () => {
    hashHistory.push(`/event-manager/`);
  };

  render() {
    const {
      data: { event, isEventLoading },
    } = this.props;

    return (
      <div id="content">
        {event.meetingId && <Helmet title={`${event.meetingId} – ${hostTitle()}`} />}
        <BigBreadcrumbs
          items={[
            'Administration',
            { title: 'Event Manager', route: '/event-manager' },
            'Detail',
          ]}
          icon="fa fa-fw fa-database"
          className=""
        />

        <WidgetGrid>
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12">
              <div className="product-content product-wrap clearfix product-deatil">
                {isEventLoading && <div className="spinner"></div>}
                {event.meetingId && (
                  <div className="row">
                    <div className="col-md-12">
                      <button
                        className="btn btn-primary pull-right"
                        onClick={this.onCancel}
                      >
                        Back
                      </button>
                      <h2 className="name">Event Details</h2>
                      <hr className="simple" />
                      <br />

                      <div className="row">
                        <div className="col-md-6">
                          <dl>
                            <dt>Event Date</dt>
                            <dd>
                              <Moment
                                date={event.meetingDate}
                                format="MM/DD/YYYY HH:mm"
                              />
                            </dd>
                            <br />

                            <dt>Event Type</dt>
                            <dd>{event.meetingType}</dd>
                            <br />

                            <dt>Event Plan</dt>
                            <dd>{event.plan}</dd>
                            <br />

                            <dt>Recap</dt>
                            <dd>{event.recap}</dd>
                            <br />

                            <dt>Employer Code</dt>
                            <dd>{event.employerCodeNumber}</dd>
                            <br />

                            <dt>Reps</dt>
                            <dd>{event.repsName}</dd>
                            <br />
                          </dl>
                        </div>
                        <div className="col-md-6">
                          <dl>
                            <dt>Client Concerns</dt>
                            <dd>{event.clientConcerns}</dd>
                            <br />

                            <dt>Overall Score</dt>
                            <dd>{event.overallScore}</dd>
                            <br />

                            <dt>Notes</dt>
                            <dd>{event.notes}</dd>
                            <br />

                            <dt>Created By</dt>
                            <dd>{event.createdByName}</dd>
                            <br />

                            <dt>Created Date</dt>
                            <dd>
                              <Moment
                                date={event.createdDate}
                                format="MM/DD/YYYY HH:mm"
                              />
                            </dd>
                            <br />
                          </dl>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </WidgetGrid>
      </div>
    );
  }
}
export default connect(
  (state) => ({
    data: state.eventmanager,
    tenantId: state.currentUser.queryParams.tenantId,
  }),
  (dispatch) => ({
    getEvent: (meetingId, params) => dispatch(requestEvent(meetingId, params)),
  }),
)(EventManagerDetail);



// WEBPACK FOOTER //
// ./src/routes/administration/containers/EventManagerDetail.js